const isStorybookMode = false;
const addStorybookToDevMenu = () => {
    // No-op for web, as we don't have a dev menu in the same way as native apps
};

export { isStorybookMode, addStorybookToDevMenu };
